import React from "react";

const Service = () => {
  return (
    <div className="container-xxl py-5">
      <div className="container py-5">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="text-secondary text-uppercase">Our Products</h6>
          <h1 className="mb-5">Explore Our Industrial Products</h1>
        </div>
        <div className="row g-4">
          <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img className="img-fluid-service" src="/img/WhatsApp Image 2025-09-06 at 7.42.10 PM.jpeg" alt="" />
              </div>
              <h4 className="mb-3">Pneumatic Grease Pumps</h4>
              <p>Efficient and reliable pumps for industrial lubrication.</p>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img className="img-fluid-service" src="/img/560 BSP.jpg" alt="" />
              </div>
              <h4 className="mb-3">Automatic Grease Feeders</h4>
              <p>Automated grease feeders for smooth machine operation.</p>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.7s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img className="img-fluid-service" src="/img/FP-7532.jpg" alt="" />
              </div>
              <h4 className="mb-3">Die Grinders</h4>
              <p>High-performance grinders for precision metalworking tasks.</p>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img className="img-fluid-service" src="/img/WhatsApp Image 2025-09-06 at 7.32.40 PM.jpeg" alt="" />
              </div>
              <h4 className="mb-3">Hydraulic Cylinder</h4>
              <p>Durable and efficient hydraulic cylinders for heavy loads.</p>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img className="img-fluid-service" src="/img/WhatsApp Image 2025-09-06 at 7.34.14 PM.jpeg" alt="" />
              </div>
              <h4 className="mb-3">Air Compressors</h4>
              <p>Powerful air compressors for industrial and workshop use.</p>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.7s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img className="img-fluid-service" src="/img/tcn-ball-valve-500x500.webp" alt="" />
              </div>
              <h4 className="mb-3">Air Blow Guns</h4>
              <p>Precision air blow guns for cleaning and drying tasks.</p>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <a href="/products" className="btn btn-primary py-3 px-5">
          Explore More
        </a>
      </div>
    </div>
  );
};

export default Service;
